/*
 * Smaakwijzer — hoptimaal.com
 * Zes tikvragen → score op smaakassen → één van vijf profielen (= ontdekbox)
 * + drie bieren uit de dagelijkse feed die nu op voorraad zijn.
 * Bron: vat33/shopify-theme/hoptimaal/assets/smaakwijzer.js
 */
(function () {
  "use strict";

  var root = document.getElementById("smaakwijzer");
  if (!root) return;

  function leesJson(id, terug) {
    try {
      var el = document.getElementById(id);
      return el ? JSON.parse(el.textContent) || terug : terug;
    } catch (e) {
      return terug;
    }
  }
  var FEED = leesJson("sw-feed", null) || { st: [], b: [] };
  var BOXEN = leesJson("sw-boxen", {});
  var BEELD = leesJson("sw-beelden", {});
  var CTX = leesJson("sw-ctx", {});
  // Teksten per taal uit de themavertalingen (locales: hoptimaal.sw.* / hoptimaal.profiel.*)
  var I = leesJson("sw-i18n", {});
  // De | t-filter levert HTML-escaped tekst (&amp;, &#39;); de quiz zet alles als textContent
  (function () {
    var dec = document.createElement("textarea");
    for (var k in I) { dec.innerHTML = I[k]; I[k] = dec.value; }
  })();
  var STIJLNAAM = leesJson("sw-stijlnamen", {});
  var REGELS = leesJson("sw-regels", {});
  var TAAL = (document.documentElement.lang || "nl").slice(0, 2);
  var ROOT = (CTX.root || "/").replace(/\/$/, "");
  function vul(t, w) { return String(t || "").replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) { return w[k] != null ? w[k] : ""; }); }

  // Assen: bitter, zoet, zuur, gebrand, fruitig, body (0–5)
  var W = [1, 1, 1.6, 1.2, 1, 0.7];
  var BASIS = [1.5, 1.8, 0.2, 0.3, 2, 2.4];

  // Profiel = gemiddelde smaak van de bieren in de box (10 okt 2026)
  var PROFIELEN = {
    "zacht-en-rond": {
      naam: "Zacht & Rond",
      label: I.p_zacht_en_rond,
      c: [1.5, 2.1, 0.1, 0.3, 1.9, 2.6],
      tekst: I.tekst_zacht_en_rond,
      box: "ontdekbox-zacht-en-rond",
    },
    "fris-en-fruitig": {
      naam: "Fris & Fruitig",
      label: I.p_fris_en_fruitig,
      c: [1.5, 1.0, 0.8, 0.0, 3.1, 2.3],
      tekst: I.tekst_fris_en_fruitig,
      box: "ontdekbox-fris-en-fruitig",
    },
    "hoppig-en-bitter": {
      naam: "Hoppig & Bitter",
      label: I.p_hoppig_en_bitter,
      c: [3.4, 1.1, 0.0, 0.0, 3.1, 2.9],
      tekst: I.tekst_hoppig_en_bitter,
      box: "ontdekbox-hoppig-en-bitter",
    },
    "donker-en-romig": {
      naam: "Donker & Romig",
      label: I.p_donker_en_romig,
      c: [1.5, 3.3, 0.0, 2.8, 1.0, 4.0],
      tekst: I.tekst_donker_en_romig,
      box: "ontdekbox-donker-en-romig",
    },
    "zonder-alcohol": {
      naam: "Alcoholarm",
      label: I.p_alcoholarm,
      c: null,
      tekst: I.tekst_alcoholarm,
      box: "ontdekbox-zonder-alcohol",
    },
  };

  // Inhoud van de boxen: die bieren raden we niet nóg eens los aan
  var IN_BOX = {
    "ontdekbox-zacht-en-rond": ["rock-city-twisted-blond", "vat33-hey-tjappie", "het-anker-gouden-carolus-classic", "de-poes-blond", "t-mirakel-de-vondst-tripel", "vat33-sloppy-joe", "bombrewery-triporteur-full-moon-12", "orval"],
    "ontdekbox-fris-en-fruitig": ["ter-dolen-wit", "kees-zeeuwse-lust", "katuiner-saison", "rock-city-hazy-pale-ale", "uiltje-dikke-lul-3-bier", "vat33-keipa-black-pepper-edition", "dois-corvos-weekend", "eleven-double-fruited-sour"],
    "ontdekbox-hoppig-en-bitter": ["the-garden-pale-ale", "two-chefs-funky-falcon", "stadshaven-brouwerij-moray-ipa", "dutch-bargain-coastal-ipa", "basqueland-gilda", "basqueland-imparable", "vat33-double-daddy", "mad-scientist-liquid-cocaine"],
    "ontdekbox-donker-en-romig": ["rock-city-brewing-smulbock", "kasteel-barista-chocolate-quad", "val-dieu-grand-cru", "rock-city-buried-treasure", "pohjala-oo", "pohjala-cocobanger"],
    "ontdekbox-zonder-alcohol": ["keipa-black-pepper-edition-non-alcoholic", "delirium-delirio", "la-trappe-nillis", "to-ol-implosion", "lervig-no-worries-grapefruit", "de-halve-maan-sportzot-1"],
  };

  // Geen bier: niet aanraden in een bierquiz
  var GEEN_BIER = ["mede", "cider"];

  // Vragen. t = tekst voor jezelf, c = tekst als cadeau. d = delta op de assen.
  var VRAGEN = [
    {
      id: "niveau",
      t: I.v_niveau,
      c: I.v_niveau_c,
      opties: [
        { id: "nieuw", t: I.o_nieuw, c: I.o_nieuw_c, beeld: "nieuw", niveau: 1 },
        { id: "af-en-toe", t: I.o_af_en_toe, c: I.o_af_en_toe_c, beeld: "af-en-toe", niveau: 2 },
        { id: "weet-wat", t: I.o_weet_wat, c: I.o_weet_wat_c, beeld: "weet-wat", niveau: 3 },
      ],
    },
    {
      id: "drinkt",
      t: I.v_drinkt,
      c: I.v_drinkt_c,
      opties: [
        { id: "pils", t: I.o_pils, beeld: "pils", d: [0.3, 0.2, 0, 0, 0, -0.3] },
        { id: "wijn", t: I.o_wijn, beeld: "wijn", d: [0, 0, 1, 0, 1, 0] },
        { id: "cocktails", t: I.o_cocktails, beeld: "cocktails", d: [0, 0.8, 0.3, 0, 1.5, 0] },
        { id: "koffie", t: I.o_koffie_thee, beeld: "koffie", d: [0, 0, 0, 1.5, 0, 1] },
        { id: "fris", t: I.o_fris, beeld: "fris", d: [-0.8, 1, 0, 0, 0.5, -0.3] },
      ],
    },
    {
      id: "koffie",
      t: I.v_koffie,
      c: I.v_koffie,
      opties: [
        { id: "zwart", t: I.o_zwart, beeld: "koffie-zwart", d: [1.3, 0, 0, 1.2, 0, 0] },
        { id: "melk", t: I.o_melk, beeld: "koffie-melk", d: [0, 0.8, 0, 0.8, 0, 0.6] },
        { id: "niet", t: I.o_liever_niet, beeld: "koffie-niet", d: [0, 0, 0, -1, 0, 0] },
      ],
    },
    {
      id: "fruit",
      t: I.v_fruit,
      c: I.v_fruit,
      opties: [
        { id: "grapefruit", t: I.o_grapefruit, beeld: "grapefruit", d: [2, 0, 0, 0, 0.6, 0] },
        { id: "mango", t: I.o_mango, beeld: "mango", d: [-0.3, 0.3, 0, 0, 1.5, 0] },
      ],
      geen: { id: "geen", t: I.geen_van_beide, d: [-0.5, 0.3, 0, 0, -0.7, 0] },
    },
    {
      id: "snoep",
      t: I.v_snoep,
      c: I.v_snoep,
      opties: [
        { id: "zuur", t: I.o_zure_snoepjes, beeld: "zure-snoepjes", d: [0, 0, 2, 0, 0.5, 0] },
        { id: "chocola", t: I.o_chocola, beeld: "chocola", d: [0, 0.5, 0, 1.2, -0.3, 1] },
      ],
      geen: { id: "geen", t: I.geen_van_beide, d: [0, 0, 0, 0, 0, 0] },
    },
    {
      id: "alcohol",
      t: I.v_alcohol,
      c: I.v_alcohol,
      opties: [
        { id: "zonder", t: I.o_alcoholarm, sub: I.o_alcoholarm_sub, beeld: "zonder-alcohol", d: [0, 0, 0, 0, 0, 0], max: 5 },
        { id: "licht", t: I.o_licht, sub: I.o_licht_sub, beeld: "licht", d: [0, 0, 0, -0.5, 0, -1], max: 65 },
        { id: "gemiddeld", t: I.o_gemiddeld, sub: I.o_gemiddeld_sub, beeld: "gemiddeld", d: [0, 0, 0, 0, 0, 0], max: 85 },
        { id: "stevig", t: I.o_stevig, beeld: "stevig", d: [0, 0.5, 0, 0.3, 0, 1], max: 999 },
      ],
    },
  ];

  var staat = { voor: null, stap: -1, antwoorden: {}, gestart: false };

  // ---------- Klaviyo (onsite-script staat al op hoptimaal.com) ----------
  function kl(event, props) {
    try {
      var k = window.klaviyo;
      if (!k) return;
      var p = Object.assign({ Quiz: "Smaakwijzer", Taal: TAAL, Voor: staat.voor === "cadeau" ? "cadeau" : "mezelf" }, props || {});
      if (typeof k.track === "function") k.track(event, p);
      else if (typeof k.push === "function") k.push(["track", event, p]);
    } catch (e) {}
  }

  // ---------- helpers ----------
  function el(tag, attrs, kinderen) {
    var e = document.createElement(tag);
    for (var k in attrs || {}) {
      if (k === "class") e.className = attrs[k];
      else if (k === "html") e.innerHTML = attrs[k];
      else if (k.slice(0, 2) === "on") e.addEventListener(k.slice(2), attrs[k]);
      else if (attrs[k] != null) e.setAttribute(k, attrs[k]);
    }
    (kinderen || []).forEach(function (c) {
      if (c == null) return;
      e.appendChild(typeof c === "string" ? document.createTextNode(c) : c);
    });
    return e;
  }
  function absoluut(u) {
    if (!u) return "";
    if (u.slice(0, 2) === "//") return "https:" + u;
    if (u.charAt(0) === "/") return "https://hoptimaal.com" + u;
    return u;
  }
  function euro(cent) {
    var bedrag = (cent / 100).toFixed(2);
    return "€" + (TAAL === "en" ? bedrag : bedrag.replace(".", ","));
  }
  // Prijs zonder €-teken op de pagina (17 okt 2026); euro() blijft voor de Klaviyo-mail
  function prijs(cent) {
    var bedrag = (cent / 100).toFixed(2);
    return TAAL === "en" ? bedrag : bedrag.replace(".", ",");
  }
  function tekst(v) {
    return staat.voor === "cadeau" && v.c ? v.c : v.t;
  }
  function naarBoven() {
    var top = root.getBoundingClientRect().top + window.pageYOffset - 90;
    if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: "smooth" });
  }
  function voet() {
    return el("p", { class: "sw-voet" }, [I.voet]);
  }

  // ---------- schermen ----------
  function render() {
    root.innerHTML = "";
    if (staat.stap === -1) return renderStart();
    if (staat.stap === "weet-wat") return renderWeetWat();
    if (staat.stap >= VRAGEN.length) return renderUitslag();
    renderVraag(VRAGEN[staat.stap]);
  }

  function renderStart() {
    root.appendChild(
      el("div", { class: "sw-start" }, [
        el("p", { class: "sw-kicker" }, [I.kicker]),
        el("h1", { class: "sw-titel" }, [I.start_titel]),
        el("p", { class: "sw-intro" }, [I.start_intro]),
        el("div", { class: "sw-opties sw-opties--2" }, [
          optieKnop({ t: I.voor_mezelf, beeld: "voor-mezelf" }, function () {
            begin("mezelf");
          }),
          optieKnop({ t: I.cadeau, beeld: "cadeau" }, function () {
            begin("cadeau");
          }),
        ]),
        voet(),
      ])
    );
  }

  function begin(voor) {
    staat.voor = voor;
    staat.stap = 0;
    staat.antwoorden = {};
    if (!staat.gestart) kl("Quiz Started");
    staat.gestart = true;
    render();
    naarBoven();
  }

  function optieKnop(o, klik, gekozen) {
    return el(
      "button",
      { type: "button", class: "sw-optie" + (gekozen ? " is-gekozen" : ""), onclick: klik },
      [
        o.beeld && BEELD[o.beeld] ? el("img", { src: BEELD[o.beeld], alt: "", width: "180", height: "180", loading: "eager" }) : null,
        el("span", { class: "sw-optie__t" }, [tekst(o)]),
        o.sub ? el("span", { class: "sw-optie__sub" }, [o.sub]) : null,
      ]
    );
  }

  function renderVraag(v) {
    var n = staat.stap;
    var kies = function (o) {
      return function () {
        staat.antwoorden[v.id] = o;
        if (v.id === "niveau" && o.id === "weet-wat" && staat.voor !== "cadeau") {
          staat.stap = "weet-wat";
        } else {
          staat.stap = n + 1;
        }
        render();
        naarBoven();
      };
    };
    var huidig = staat.antwoorden[v.id];
    root.appendChild(
      el("div", { class: "sw-vraag" }, [
        el("div", { class: "sw-balk" }, [
          el("button", { type: "button", class: "sw-terug", "aria-label": I.vorige, onclick: terug }, ["←"]),
          el("div", { class: "sw-voortgang", role: "progressbar", "aria-valuemin": "0", "aria-valuemax": String(VRAGEN.length), "aria-valuenow": String(n + 1) }, [
            el("span", { style: "width:" + Math.round(((n + 1) / VRAGEN.length) * 100) + "%" }),
          ]),
          el("span", { class: "sw-teller" }, [n + 1 + "/" + VRAGEN.length]),
        ]),
        el("h2", { class: "sw-vraag__t" }, [tekst(v)]),
        el(
          "div",
          { class: "sw-opties sw-opties--" + v.opties.length },
          v.opties.map(function (o) {
            return optieKnop(o, kies(o), huidig && huidig.id === o.id);
          })
        ),
        v.geen ? el("button", { type: "button", class: "sw-geen", onclick: kies(v.geen) }, [v.geen.t]) : null,
      ])
    );
  }

  function terug() {
    if (staat.stap === "weet-wat") staat.stap = 0;
    else if (staat.stap === 0) staat.stap = -1;
    else staat.stap = staat.stap - 1;
    render();
  }

  function renderWeetWat() {
    root.appendChild(
      el("div", { class: "sw-start" }, [
        el("h2", { class: "sw-vraag__t" }, [I.weet_wat_titel]),
        el("p", { class: "sw-intro" }, [I.weet_wat_intro]),
        el("div", { class: "sw-knoppen" }, [
          el("a", { class: "sw-knop", href: CTX.nieuw || "/collections/speciaalbier-kopen" }, [I.bekijk_nieuw]),
          el(
            "button",
            {
              type: "button",
              class: "sw-knop sw-knop--licht",
              onclick: function () {
                staat.stap = 1;
                render();
              },
            },
            [I.toch_doen]
          ),
        ]),
        voet(),
      ])
    );
  }

  // ---------- uitslag ----------
  function vector() {
    var v = BASIS.slice();
    VRAGEN.forEach(function (q) {
      var a = staat.antwoorden[q.id];
      if (a && a.d) for (var i = 0; i < 6; i++) v[i] += a.d[i];
    });
    return v;
  }
  function afstand(a, b) {
    var s = 0;
    for (var i = 0; i < 6; i++) s += W[i] * (a[i] - b[i]) * (a[i] - b[i]);
    return s;
  }
  function kiesProfiel(v) {
    var alc = staat.antwoorden.alcohol;
    if (alc && alc.id === "zonder") return "zonder-alcohol";
    var beste = null,
      min = Infinity;
    for (var k in PROFIELEN) {
      if (!PROFIELEN[k].c) continue;
      var d = afstand(v, PROFIELEN[k].c);
      if (d < min) {
        min = d;
        beste = k;
      }
    }
    return beste;
  }

  function kandidaten(v, profielKey) {
    var alc = staat.antwoorden.alcohol || { max: 999 };
    var niveau = (staat.antwoorden.niveau || {}).niveau || 2;
    var uitsluiten = IN_BOX[PROFIELEN[profielKey].box] || [];
    var lijst = [];
    (FEED.b || []).forEach(function (b) {
      var abv = b[2];
      var stijlHandle = (FEED.st[b[1]] || [])[0];
      // tot en met 0,5%: wettelijk alcoholvrij (≤ 0,1%) of alcoholarm, valt niet onder de Alcoholwet
      var alcoholarm = (abv >= 0 && abv <= 5) || stijlHandle === "alcoholvrij";
      if (alc.id === "zonder" ? !alcoholarm : alcoholarm || abv > alc.max) return;
      if (uitsluiten.indexOf(b[0]) !== -1) return;
      if (GEEN_BIER.indexOf(stijlHandle) !== -1) return;
      var s = b[3].split("").map(Number);
      var straf = b[4] > niveau ? (b[4] - niveau) * 6 : 0;
      lijst.push({ handle: b[0], stijl: (FEED.st[b[1]] || [])[1] || "", stijlHandle: stijlHandle, regel: b[5], score: afstand(v, s) + straf });
    });
    lijst.sort(function (a, b) {
      return a.score - b.score;
    });
    // spreiding: max één bier per stijl in de eerste ronde
    var gezien = {},
      eerst = [],
      later = [];
    lijst.forEach(function (x) {
      if (!gezien[x.stijl]) {
        gezien[x.stijl] = 1;
        eerst.push(x);
      } else later.push(x);
    });
    return eerst.slice(0, 12).concat(later.slice(0, 12));
  }

  function haalProduct(handle) {
    return fetch(ROOT + "/products/" + encodeURIComponent(handle) + ".js", { credentials: "same-origin" })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function drieBieren(lijst) {
    var gekozen = [];
    var i = 0;
    function volgende() {
      if (gekozen.length >= 3 || i >= lijst.length) return Promise.resolve(gekozen);
      var batch = lijst.slice(i, i + 4);
      i += 4;
      return Promise.all(
        batch.map(function (k) {
          return haalProduct(k.handle).then(function (p) {
            return p && p.available ? { k: k, p: p } : null;
          });
        })
      ).then(function (res) {
        res.forEach(function (x) {
          if (x && gekozen.length < 3) gekozen.push(x);
        });
        return volgende();
      });
    }
    return volgende();
  }

  function inWinkelwagen(variantId, knop, bron) {
    knop.disabled = true;
    var oud = knop.textContent;
    knop.textContent = I.even_geduld;
    fetch(ROOT + "/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error("add");
        knop.textContent = I.toegevoegd;
        knop.classList.add("is-toegevoegd");
        kl("Recommended Product Clicked", { Product: bron, Actie: "winkelwagen" });
        document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
        var link = knop.parentNode.querySelector(".sw-naar-wagen");
        if (link) link.hidden = false;
      })
      .catch(function () {
        knop.disabled = false;
        knop.textContent = oud;
        alert(I.toevoegen_mislukt);
      });
  }

  function renderUitslag() {
    var v = vector();
    var key = kiesProfiel(v);
    var prof = PROFIELEN[key];
    var box = BOXEN[prof.box];
    var antwoorden = {};
    VRAGEN.forEach(function (q) {
      if (staat.antwoorden[q.id]) antwoorden[q.id] = staat.antwoorden[q.id].id;
    });
    kl("Quiz Completed", { Smaakprofiel: prof.naam, Antwoorden: antwoorden });
    staat.uitslag = {
      profiel: prof.naam,
      antwoorden: antwoorden,
      tekst: prof.tekst,
      box: box
        ? {
            titel: box.titel,
            url: absoluut(box.url),
            beeld: absoluut(box.beeld),
            prijs: euro(box.prijs),
            los: box.los > box.prijs ? euro(box.los) : "",
            bespaar: box.los > box.prijs ? euro(box.los - box.prijs) : "",
          }
        : null,
      bieren: [],
    };

    var boxBlok = null;
    if (box) {
      var bespaar = box.los > box.prijs ? box.los - box.prijs : 0;
      boxBlok = el("div", { class: "sw-box" }, [
        el("a", { href: box.url, class: "sw-box__beeld" }, [el("img", { src: box.beeld, alt: box.titel, loading: "lazy" })]),
        el("div", { class: "sw-box__info" }, [
          el("p", { class: "sw-kicker" }, [I.begin_hier]),
          el("h3", { class: "sw-box__titel" }, [el("a", { href: box.url }, [box.titel])]),
          el("p", { class: "sw-box__tekst" }, [I.box_tekst]),
          el("p", { class: "sw-prijs" }, [
            prijs(box.prijs),
            bespaar ? el("span", { class: "sw-prijs__los" }, [I.los + " " + prijs(box.los)]) : null,
            bespaar ? el("span", { class: "sw-prijs__winst" }, [I.je_bespaart + " " + prijs(bespaar)]) : null,
          ]),
          box.beschikbaar
            ? el("div", { class: "sw-knoppen" }, [
                el(
                  "button",
                  {
                    type: "button",
                    class: "sw-knop",
                    onclick: function (e) {
                      inWinkelwagen(box.variant, e.currentTarget, prof.box);
                    },
                  },
                  [I.in_winkelwagen]
                ),
                el("a", { class: "sw-naar-wagen", href: CTX.winkelwagen || "/cart", hidden: "" }, [I.naar_wagen]),
              ])
            : el("p", { class: "sw-op" }, [I.box_op]),
        ]),
      ]);
    }

    var bierenBlok = el("div", { class: "sw-bieren" }, [el("p", { class: "sw-laden" }, [I.bieren_zoeken])]);

    // Uitslag onthouden voor de pakket-samensteller (alleen in deze browser, alleen voor jezelf)
    if (staat.voor !== "cadeau") {
      try {
        window.localStorage.setItem("hoptimaal_smaakwijzer", JSON.stringify({
          profiel: key, v: v, niveau: (staat.antwoorden.niveau || {}).niveau || 2,
          alcMax: (staat.antwoorden.alcohol || {}).max || 999, t: Date.now(),
        }));
      } catch (e) {}
    }
    var pakketBlok = null;
    if (CTX.pakket) {
      var pu = new URL(CTX.pakket, window.location.origin);
      pu.searchParams.set("smaak", key);
      pu.searchParams.set("voor", staat.voor === "cadeau" ? "cadeau" : "mezelf");
      pakketBlok = el("div", { class: "sw-pakket" }, [
        el("div", {}, [
          el("h3", { class: "sw-sub" }, [I.pakket_titel]),
          el("p", { class: "sw-pakket__t" }, [I.pakket_tekst]),
        ]),
        el("a", { class: "sw-knop sw-knop--licht", href: pu.pathname + pu.search, onclick: function () { kl("Bierpakket Doorgeklikt", { Smaakprofiel: prof.naam }); } }, [I.pakket_knop]),
      ]);
    }

    root.appendChild(
      el("div", { class: "sw-uitslag" }, [
        el("p", { class: "sw-kicker" }, [staat.voor === "cadeau" ? I.profiel_ontvanger : I.jouw_profiel]),
        el("h2", { class: "sw-titel" }, [prof.label || prof.naam]),
        el("p", { class: "sw-intro" }, [prof.tekst]),
        boxBlok,
        pakketBlok,
        el("h3", { class: "sw-sub" }, [I.of_een_bier]),
        bierenBlok,
        mailBlok(prof),
        el("div", { class: "sw-opnieuw" }, [
          el(
            "button",
            {
              type: "button",
              class: "sw-geen",
              onclick: function () {
                staat.stap = -1;
                render();
                naarBoven();
              },
            },
            [I.opnieuw]
          ),
        ]),
        voet(),
      ])
    );

    // Losse bieren: half de eigen antwoorden, half het profiel, zodat ze bij de box passen
    var doel = prof.c ? v.map(function (x, i) { return (x + prof.c[i]) / 2; }) : v;
    drieBieren(kandidaten(doel, key)).then(function (lijst) {
      bierenBlok.innerHTML = "";
      if (!lijst.length) {
        bierenBlok.appendChild(el("p", { class: "sw-laden" }, [I.geen_bieren]));
        return;
      }
      kl("Recommendation Viewed", { Smaakprofiel: prof.naam, Bieren: lijst.map(function (x) { return x.k.handle; }) });
      // voor de welkomstmail: precies de bieren die iemand hier zag
      staat.uitslag.bieren = lijst.map(function (x) {
        return {
          titel: x.p.title,
          url: absoluut(x.p.url),
          beeld: x.p.featured_image ? absoluut(x.p.featured_image) + (x.p.featured_image.indexOf("?") > -1 ? "&" : "?") + "width=300" : "",
          stijl: x.k.stijl,
          regel: x.k.regel || "",
          prijs: euro(x.p.price),
        };
      });
      lijst.forEach(function (x) {
        var p = x.p;
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf("?") > -1 ? "&" : "?") + "width=400" : "";
        bierenBlok.appendChild(
          el("div", { class: "sw-bier" }, [
            el("a", { href: p.url, class: "sw-bier__beeld" }, [img ? el("img", { src: img, alt: p.title, loading: "lazy" }) : null]),
            el("div", { class: "sw-bier__info" }, [
              el("a", { href: p.url, class: "sw-bier__titel" }, [p.title]),
              el("p", { class: "sw-bier__stijl" }, [x.k.stijlHandle ? el("a", { href: ROOT + "/pages/bierschool/" + x.k.stijlHandle, title: vul(I.stijl_link_titel, { stijl: STIJLNAAM[x.k.stijlHandle] || x.k.stijl }) }, [STIJLNAAM[x.k.stijlHandle] || x.k.stijl]) : x.k.stijl]),
              (REGELS[x.k.handle] || x.k.regel) ? el("p", { class: "sw-bier__regel" }, [REGELS[x.k.handle] || x.k.regel]) : null,
              el("p", { class: "sw-bier__prijs" }, [prijs(p.price)]),
              el(
                "button",
                {
                  type: "button",
                  class: "sw-knop sw-knop--klein",
                  onclick: function (e) {
                    inWinkelwagen(p.variants[0].id, e.currentTarget, p.handle);
                  },
                },
                [I.in_winkelwagen]
              ),
              el("a", { class: "sw-naar-wagen", href: CTX.winkelwagen || "/cart", hidden: "" }, [I.naar_wagen]),
            ]),
          ])
        );
      });
    });
  }

  // Aanmelden: alleen met expliciete toestemming; zonder vinkje gaat er niets weg.
  function mailBlok(prof) {
    var status = el("p", { class: "sw-mail__status", "aria-live": "polite" });
    var email = el("input", { type: "email", name: "email", required: "", autocomplete: "email", placeholder: I.mail_placeholder, value: CTX.klant || null });
    var vink = el("input", { type: "checkbox", name: "toestemming", required: "" });
    var form = el(
      "form",
      {
        class: "sw-mail",
        novalidate: "",
        onsubmit: function (e) {
          e.preventDefault();
          if (!email.value || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.value)) {
            status.textContent = I.mail_ongeldig;
            return;
          }
          if (!vink.checked) {
            status.textContent = I.mail_geen_vink;
            return;
          }
          var knop = form.querySelector("button");
          knop.disabled = true;
          aanmelden(email.value.trim(), prof)
            .then(function () {
              form.innerHTML = "";
              form.appendChild(el("p", { class: "sw-mail__klaar" }, [I.mail_klaar]));
            })
            .catch(function () {
              knop.disabled = false;
              status.textContent = I.mail_mislukt;
            });
        },
      },
      [
        el("h3", { class: "sw-sub" }, [I.mail_titel]),
        el("p", { class: "sw-mail__uitleg" }, [vul(I.mail_uitleg, { profiel: prof.label || prof.naam })]),
        el("div", { class: "sw-mail__rij" }, [email]),
        el("label", { class: "sw-mail__vink" }, [vink, el("span", {}, [I.mail_vink])]),
        el("button", { type: "submit", class: "sw-knop sw-mail__knop" }, [I.mail_knop]),
        status,
      ]
    );
    return form;
  }

  function aanmelden(email, prof) {
    var props = {
      Smaakprofiel: prof.naam,
      "Smaakwijzer antwoorden": (staat.uitslag || {}).antwoorden || {},
      "Smaakwijzer datum": new Date().toISOString().slice(0, 10),
      "Smaakwijzer taal": TAAL,
      // Bierniveau bewust niet: een bestaande Geek mag hier niet naar Starter terug.
    };
    var body = {
      data: {
        type: "subscription",
        attributes: {
          custom_source: "Smaakwijzer",
          profile: { data: { type: "profile", attributes: { email: email, properties: props } } },
        },
        relationships: { list: { data: { type: "list", id: "Vp7gd9" } } },
      },
    };
    return fetch("https://a.klaviyo.com/client/subscriptions?company_id=V6BeY6", {
      method: "POST",
      headers: { "Content-Type": "application/vnd.api+json", revision: "2025-07-15" },
      body: JSON.stringify(body),
    }).then(function (r) {
      if (!r.ok) throw new Error("klaviyo " + r.status);
      try {
        if (window.klaviyo && typeof window.klaviyo.identify === "function") window.klaviyo.identify({ email: email });
      } catch (e) {}
      kl("Quiz Subscribed", { Smaakprofiel: prof.naam, Taal: TAAL });
      // De welkomstmail is (nog) alleen Nederlands: EN/DE-aanmelders komen wel op de lijst, maar niet in die flow
      if (TAAL !== "nl") return;
      // Trigger voor de welkomstmail-flow ("Smaakwijzer Aangemeld"); mislukt dit, dan blijft de aanmelding staan
      var u = staat.uitslag || {};
      return fetch("https://a.klaviyo.com/client/events?company_id=V6BeY6", {
        method: "POST",
        headers: { "Content-Type": "application/vnd.api+json", revision: "2025-07-15" },
        body: JSON.stringify({
          data: {
            type: "event",
            attributes: {
              metric: { data: { type: "metric", attributes: { name: "Smaakwijzer Aangemeld" } } },
              profile: { data: { type: "profile", attributes: { email: email } } },
              properties: {
                Smaakprofiel: prof.naam,
                ProfielTekst: prof.tekst,
                Voor: staat.voor === "cadeau" ? "cadeau" : "mezelf",
                Box: u.box || null,
                Bieren: u.bieren || [],
              },
            },
          },
        }),
      }).catch(function () {});
    });
  }

  render();
})();
